import { Todo } from '@/common/types/databaseTypes';
import { Checkbox, Tooltip } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import CancelCheckBox from './CancelCheckBox';
import { useCancelTodo } from '../hooks/useTodoActions';

export default function TodoCheckBox({
    todo,
    onComplete,
    disabled,
}: {
    todo: Partial<Todo> | undefined;
    onComplete: (checked: boolean) => void;
    disabled?: boolean;
}) {
    const { t } = useTranslation();
    const { updateTodoCancelStatus } = useCancelTodo();
    const isCompleted = todo?.complete_date !== null;

    return (
        <>
            {todo?.cancelled_date !== null ? (
                <CancelCheckBox
                    disabled={disabled}
                    checked={todo?.cancelled_date !== null}
                    onChange={checked => {
                        void updateTodoCancelStatus({
                            todoId: todo?.id,
                            updateToCancelled: checked,
                            ownerId: todo?.user_id,
                        });
                    }}
                />
            ) : (
                <Tooltip
                    label={
                        // 비활성화 상태면 '상태값'을, 아니면 '변경될 값'을 표시
                        disabled
                            ? isCompleted
                                ? t('todo:status.completed')
                                : t('todo:status.in_progress')
                            : t('todo:component.todo_checkbox.complete')
                    }
                    withArrow
                >
                    <Checkbox
                        tabIndex={-1}
                        color="gray.5"
                        checked={isCompleted}
                        onChange={e => {
                            if (disabled) return;
                            onComplete(e.currentTarget.checked);
                        }}
                        aria-label={
                            isCompleted ? 'Completed task' : 'Incomplete task'
                        }
                        size="xs"
                        styles={{
                            input: {
                                cursor: disabled ? 'not-allowed' : 'pointer',
                            },
                        }}
                        // disabled={disabled}
                    />
                </Tooltip>
            )}
        </>
    );
}
